import { render, staticRenderFns } from "./d3-simple-legend.vue?vue&type=template&id=608521af&scoped=true"
import script from "./d3-simple-legend.vue?vue&type=script&lang=js"
export * from "./d3-simple-legend.vue?vue&type=script&lang=js"
import style0 from "./d3-simple-legend.vue?vue&type=style&index=0&id=608521af&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608521af",
  null
  
)

export default component.exports